import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { html as oghtml, utils } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { Command, CommandGroupSource, CommandQuery } from "@omegagrid/commands";
import rp, { CommandProvider, RequestParams } from "@reporting/rp-app-host";
import { TableDefinition } from "@reporting/rp-types/mdm";
import { TableType, TableTypes } from "./types";

export type SearchResultCommand = Command & {
	props: {
		preview?: string;
	};
}

function highlightText(text: string, term: string): string {
	const m = (new RegExp(utils.escapeRegExp(term), 'gi'));
	if (m == null) return null;
	const matches: [number, number][] = [];
	let match: RegExpExecArray;
	while (match = m.exec(text)) {
		matches.push([match.index, match.index + term.length]);
	}
	return oghtml.highlightText(text, matches);
}

export class MDMSearchProvider implements CommandProvider {

	id = 'MDM';
	title = msg('MDM');
	placeholder = msg('Search MDM tables...');
	triggerCommand = 'm';
	lastQuery: CommandQuery;

	getGroups = async (query?: CommandQuery): Promise<CommandGroupSource[]> => {
		this.lastQuery = query;
		if (!query?.filter) return [];

		const params: RequestParams = {
			fields: ['id_md', 'accounting', 'md_name', 'type'],
			order: ['md_name'],
			where: `md_name='~${query.filter}~'`
		};

		const tables = await rp.ms('mdm').get<TableDefinition[]>(`tableDefinitions`, params);
		if (tables.length === 0) return [];

		const group: CommandGroupSource = {id: 'default', name: msg('Tables'), commands: []};
		const groups: CommandGroupSource[] = [group];

		for (const table of tables) {
			group.commands.push({
				id: `mdm-values-${table.type}-${table.id_md}`,
				name: table.md_name,
				group: group.id, 
				props: { type: table.type }, 
				exec: (c) => {
					rp.host.open(c.id, {title: c.name});
				}
			});
		}

		return groups;
	}

	getOptions = () => ({
		commandRenderer: (div: HTMLDivElement, command: Command) => {
			div.style.height = '22px';
			div.style.lineHeight = '20px';

			const nameHTML = command.name && this.lastQuery.filter 
				? highlightText(command.name, this.lastQuery.filter) 
				: command.name;

			return html`
				<div class="command" style="display: flex">
					<og-button
						style="padding-right: 5px; padding-bottom: 4px;"
						color="transparent"
						icon="${command.props?.type as TableType == TableTypes.SQL ? 'database' : 'table'}">
					</og-button>
					<div style="flex: 1">${unsafeHTML(nameHTML)}</div>
				</div>
			`;
		}
	});
	
}
